import React, { useReducer } from 'react'
import ProductContext from './productContext'
import ProductReducer from './productReducer'
import { apiCall } from '../../common/api'
import { response } from '../common'

import {
    GET_ALL_PRODUCTS,
    GET_ALL_ACTIVE_AUCTIONS,
    GET_SINGLE_PROJECT,
    GET_SINGLE_PROJECT_TIMES,
    GET_SINGLE_PROJECT_LABEL,
    GET_ALL_BID_HISTORY,
    GET_ALL_PROXY_HISTORY,
    GET_ALL_API_LOGS,
    GET_ALL_TTWBID_HISTORY,
    RESPONSE_STATUS,
    RECONCILIATION,
    CLEAR_RESPONSE,
    GET_ALL_ROYALTY_INPUTS,
    GET_SYNC_DASHBOARD_DATA,
    GET_ALL_PROJECT_ACCESS,
    GET_ALL_OFFERS,
    GET_EDIT_ACTION_STATUS,
    CLEAR_RESPONSE_EDIT,
} from './productTypes'

const ProductState = (props) => {
    const initialState = {
        all_products: {
            records: [],
            totalRecords: 0,
            setDisp: '',
            summary: {},
        },
        all_offers: {
            records: [],
            totalRecords: 0,
            from: '',
        },
        all_active_auctions: {
            activelots: [],
        },
        single_project: {
            record: {},
            from: '',
        },
        project_timing_config: {
            date_added: null,
            date_closed: null,
            from: '',
        },
        single_project_label: {
            record: {},
            from: '',
        },
        search_allbidhistory: {
            records: [],
            totalRecords: 0,
            setDisp: '',
            projectRecords: null,
        },
        search_allproxyhistory: {
            records: [],
            totalRecords: 0,
            setDisp: '',
        },
        mainDashboardSync: {
            productCount: { active: 0, removed: 0 },
            third_party_prdtCount: { active: 0, removed: 0 },
        },
        all_project_access_req: {
            records: [],
            totalRecords: 0,
            setDisp: '',
            from: '',
        },
        reconcilation: null,
        search_allttwbidhistory: [],
        responseStatus: null,
        all_royalty_inputs: {
            records: [],
            totalRecords: 0,
            setDisp: '',
        },
        search_allapilogs: {
            records: [],
            totalRecords: 0,
            setDisp: '',
        },
        edit_action_status: null,
    }

    const [state, dispatch] = useReducer(ProductReducer, initialState)
    let resp = new response(dispatch, RESPONSE_STATUS)

    const getAllMakeOffers = async (formData, from) => {
        try {
            const [res] = await Promise.all([
                apiCall('post', 'adminoffers', formData, '', 'product'),
            ])
            from = from ? from : 'getAllOffers'
            if (res.data.status === 'success') {
                dispatch({
                    type: GET_ALL_OFFERS,
                    payload: {
                        records: res.data.data.responseData.records.length
                            ? res.data.data.responseData.records
                            : [],
                        totalRecords: res.data.data.responseData.totalRecords,
                        from: from,
                    },
                })
            } else if (res.data.status === 'error') {
                resp.commonResponse(res.data, from)
            } else {
                resp.commonErrorResponse(from)
            }
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const getAllAdminOffers = async (formData, from) => {
        try {
            const [res] = await Promise.all([
                apiCall('post', 'adminoffers', formData, '', 'product'),
            ])
            from = from ? from : 'getAllAdminOffers'
            if (res.data.status === 'success') {
                dispatch({
                    type: GET_ALL_OFFERS,
                    payload: {
                        records: res.data.data.responseData.records.length
                            ? res.data.data.responseData.records
                            : [],
                        totalRecords: res.data.data.responseData.totalRecords,
                        from: from,
                    },
                })
            } else if (res.data.status === 'error') {
                resp.commonResponse(res.data, from)
            } else {
                resp.commonErrorResponse(from)
            }
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const getAllOffers = async (formData, from) => {
        try {
            const [res] = await Promise.all([
                apiCall(
                    'post',
                    'index/offer/offer/getAllOffers',
                    formData,
                    '',
                    '',
                    '',
                    true
                ),
            ])
            from = from ? from : 'getAllOffers'
            if (res.data.status === 'success') {
                dispatch({
                    type: GET_ALL_OFFERS,
                    payload: {
                        records: res.data.data.responseData.records.length
                            ? res.data.data.responseData.records
                            : [],
                        totalRecords: res.data.data.responseData.totalRecords,
                        from: from,
                    },
                })
            } else if (res.data.status === 'error') {
                resp.commonResponse(res.data, from)
            } else {
                resp.commonErrorResponse(from)
            }
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }
    const getAllProducts = async (formData, from) => {
        try {
            const [res] = await Promise.all([
                apiCall('post', 'listings', formData, '', 'product'),
            ])
            from = from ? from : 'Communicationtemplates'
            if (res.data.status === 'success') {
                dispatch({
                    type: GET_ALL_PRODUCTS,
                    payload: {
                        records: res.data.data.responseData.records.length
                            ? res.data.data.responseData.records
                            : [],
                        totalRecords: res.data.data.responseData.totalRecords,
                        setDisp: res.data.data.responseData.setDisp,
                        summary: res.data.data.responseData.summary,
                        from: from,
                    },
                })
                dispatch({
                    type: GET_ALL_ACTIVE_AUCTIONS,
                    payload: res.data.data.responseData.activelots.length
                        ? res.data.data.responseData.activelots
                        : [],
                })
            } else if (res.data.status === 'error') {
                resp.commonResponse(res.data, from)
            } else {
                resp.commonErrorResponse(from)
            }
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const changeProductStatus = async (formData, from, isCustom = false) => {
        try {
            from = from ? from : 'productchange'
            const [res] = await Promise.all([
                apiCall(
                    'post',
                    'changeStatus',
                    formData,
                    '',
                    isCustom ? `custom/product` : `product`,
                    '',
                    '',
                    isCustom
                ),
            ])
            resp.commonResponse(res.data, from)
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const ChangeAuctionIdInProject = async (
        formData,
        from,
        isCustom = false
    ) => {
        try {
            from = from ? from : 'productchange'
            const [res] = await Promise.all([
                apiCall(
                    'post',
                    'ChangeAuctionIdInProject',
                    formData,
                    '',
                    isCustom ? `custom/product` : `product`,
                    '',
                    '',
                    isCustom
                ),
            ])
            resp.commonResponse(res.data, from)
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }
    const changeOfferStatus = async (formData, from) => {
        try {
            //const from = 'productchange'
            from = from ? from : 'offerChange'
            const [res] = await Promise.all([
                apiCall('post', 'changeOfferStatus', formData, '', 'product'),
            ])
            resp.commonResponse(res.data, from)
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const projectAction = async (formData, fromVariable, isCustom = false) => {
        try {
            const from = fromVariable || 'projectAction'
            const [res] = await Promise.all([
                apiCall(
                    'post',
                    'projectAction',
                    formData,
                    '',
                    isCustom ? `custom/product` : `product`,
                    '',
                    '',
                    isCustom
                ),
            ])
            resp.commonResponse(res.data, from)
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const multiProjectAction = async (
        formData,
        fromVariable,
        isCustom = false
    ) => {
        try {
            const from = fromVariable || 'multiProjectAction'
            const [res] = await Promise.all([
                apiCall(
                    'post',
                    'multiProjectAction',
                    formData,
                    '',
                    isCustom ? `custom/product` : `product`,
                    '',
                    '',
                    isCustom
                ),
            ])
            resp.commonResponse(res.data, from)
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const editAction = async (formData, noAlert) => {
        try {
            const from = 'editAction'
            const [res] = await Promise.all([
                apiCall('post', 'editAction', formData, '', 'product'),
            ])
            if (res.data) {
                dispatch({
                    type: GET_EDIT_ACTION_STATUS,
                    payload: res.data,
                })
            }
            resp.commonResponse(res.data, from, noAlert)
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const getProjectAccessRequest = async (formData, fromVariable) => {
        try {
            const [res] = await Promise.all([
                apiCall(
                    'post',
                    'getProjectAccessRequest',
                    formData,
                    '',
                    'product'
                ),
            ])
            const from = fromVariable ? fromVariable : 'getAuctionAccessRequest'
            if (res.data.status === 'success') {
                dispatch({
                    type: GET_ALL_PROJECT_ACCESS,
                    payload: {
                        records: res.data.data.responseData.records.length
                            ? res.data.data.responseData.records
                            : [],
                        totalRecords: res.data.data.responseData.totalRecords,
                        setDisp: res.data.data.responseData.setDisp,
                        from: fromVariable,
                    },
                })
            } else if (res.data.status === 'error') {
                resp.commonResponse(res.data, from)
            } else {
                resp.commonErrorResponse(from)
            }
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const projectAccessReqStatus = async (formData) => {
        try {
            const from = 'projectAccessReqStatus'
            const [res] = await Promise.all([
                apiCall(
                    'post',
                    'projectAccessReqStatus',
                    formData,
                    '',
                    'product'
                ),
            ])
            resp.commonResponse(res.data, from)
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const addItemToCart = async (formData) => {
        try {
            const from = 'addItemToCart'
            const [res] = await Promise.all([
                apiCall('post', 'addItemToCart', formData, '', 'product'),
            ])
            resp.commonResponse(res.data, from)
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const bulkProjectAction = async (formData) => {
        const from = 'bulkProjectAction'
        try {
            const [res] = await Promise.all([
                apiCall(
                    'post',
                    formData?.quick ? 'quickBulkProjectAction' : from,
                    formData,
                    '',
                    'product'
                ),
            ])
            resp.commonResponse(res.data, from)
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const uploadXLSXFile = async (
        formData,
        isCustom = false,
        CustomUrl,
        fromVariable = ''
    ) => {
        const from = fromVariable || 'uploadXLSXFile'
        try {
            const [res] = await Promise.all([
                apiCall(
                    'post',
                    'uploadXLSXFile',
                    formData,
                    '',
                    isCustom
                        ? CustomUrl
                            ? CustomUrl
                            : `custom/product`
                        : `product`,
                    '',
                    '',
                    isCustom
                ),
            ])
            resp.commonResponse(res.data, from)
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const bulkProjectImageAction = async (
        formData,
        isCustom = false,
        CustomUrl
    ) => {
        const from = 'bulkProjectImageAction'
        try {
            const [res] = await Promise.all([
                apiCall(
                    'post',
                    from,
                    formData,
                    '',
                    isCustom
                        ? CustomUrl
                            ? CustomUrl
                            : `custom/product`
                        : `product`,
                    '',
                    '',
                    isCustom
                ),
            ])
            resp.commonResponse(res.data, from)
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const getAllBidHistory = async (formData, fromVariable) => {
        try {
            const [res] = await Promise.all([
                apiCall('post', 'bidhistory', formData, '', 'product'),
            ])
            const from = 'search'
            if (res.data.status === 'success') {
                dispatch({
                    type: GET_ALL_BID_HISTORY,
                    payload: {
                        records: res.data.data.responseData.records.length
                            ? res.data.data.responseData.records
                            : [],
                        projectRecords:
                            res.data.data.responseData.projectRecords,
                        totalRecords: res.data.data.responseData.totalRecords,
                        setDisp: res.data.data.responseData.setDisp,
                        from: fromVariable || 'bidhistory',
                    },
                })
            } else if (res.data.status === 'error') {
                resp.commonResponse(res.data, from)
            } else {
                resp.commonErrorResponse(from)
            }
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const getAllProxyHistory = async (formData, fromVariable) => {
        try {
            const [res] = await Promise.all([
                apiCall('post', 'proxyhistory', formData, '', 'product'),
            ])
            const from = 'search'
            if (res.data.status === 'success') {
                dispatch({
                    type: GET_ALL_PROXY_HISTORY,
                    payload: {
                        records: res.data.data.responseData.records.length
                            ? res.data.data.responseData.records
                            : [],
                        totalRecords: res.data.data.responseData.totalRecords,
                        setDisp: res.data.data.responseData.setDisp,
                        from: fromVariable || 'proxyhistory',
                    },
                })
            } else if (res.data.status === 'error') {
                resp.commonResponse(res.data, from)
            } else {
                resp.commonErrorResponse(from)
            }
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const getCloseTimeConfiguration = async (formData, fromVariable) => {
        try {
            const from = 'getCloseTimeConfiguration'
            const [res] = await Promise.all([
                apiCall(
                    'post',
                    'getCloseTimeConfiguration',
                    formData,
                    '',
                    'product'
                ),
            ])
            if (res.data.status === 'success') {
                dispatch({
                    type: GET_SINGLE_PROJECT_TIMES,
                    payload: {
                        date_added: res.data.data.responseData.date_added
                            ? res.data.data.responseData.date_added
                            : null,
                        date_closed: res.data.data.responseData.date_closed
                            ? res.data.data.responseData.date_closed
                            : null,
                        from: fromVariable ? fromVariable : from,
                    },
                })
            } else if (res.data.status === 'error') {
                resp.commonResponse(res.data, from)
            } else {
                resp.commonErrorResponse(from)
            }
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const getSingleProject = async (formData, fromVariable) => {
        try {
            const from = 'getSingleProject'
            const [res] = await Promise.all([
                apiCall('post', 'getSingleProject', formData, '', 'product'),
            ])
            if (res.data.status === 'success') {
                dispatch({
                    type: GET_SINGLE_PROJECT,
                    payload: {
                        record: res.data.data.responseData.record
                            ? res.data.data.responseData.record
                            : {},
                        from: fromVariable ? fromVariable : from,
                    },
                })
            } else if (res.data.status === 'error') {
                resp.commonResponse(res.data, from)
            } else {
                resp.commonErrorResponse(from)
            }
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const getSingleProjectforPrintLabel = async (formData, fromVariable) => {
        try {
            const from = 'getSingleProjectforPrintLabel'
            const [res] = await Promise.all([
                apiCall(
                    'post',
                    'getSingleProjectforPrintLabel',
                    formData,
                    '',
                    'product'
                ),
            ])
            if (res.data.status === 'success') {
                dispatch({
                    type: GET_SINGLE_PROJECT_LABEL,
                    payload: {
                        record: res.data.data.responseData.record
                            ? res.data.data.responseData.record
                            : {},
                        from: fromVariable ? fromVariable : from,
                    },
                })
            } else if (res.data.status === 'error') {
                resp.commonResponse(res.data, from)
            } else {
                resp.commonErrorResponse(from)
            }
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    // only for songvest
    const getReconsolationData = async (formData) => {
        try {
            const [res] = await Promise.all([
                apiCall('post', 'reconsolationReport', formData, '', 'product'),
            ])
            const from = 'reconsolationReport'
            if (res.data.status === 'success') {
                dispatch({
                    type: RECONCILIATION,
                    payload: res.data.data.responseData,
                })
            } else if (res.data.status === 'error') {
                resp.commonResponse(res.data, from)
            } else {
                resp.commonErrorResponse(from)
            }
        } catch (err) {
            console.log('err', err)
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const getAllTtwBidHistory = async (formData) => {
        try {
            const [res] = await Promise.all([
                apiCall('post', 'ttwbidhistory', formData, '', 'product'),
            ])
            const from = 'search'
            if (res.data.status === 'success') {
                dispatch({
                    type: GET_ALL_TTWBID_HISTORY,
                    payload: {
                        records: res.data.data.responseData.records.length
                            ? res.data.data.responseData.records
                            : [],
                        totalRecords: res.data.data.responseData.totalRecords,
                        setDisp: res.data.data.responseData.setDisp,
                        sorts: res.data.data.responseData.sorts,
                    },
                })
            } else if (res.data.status === 'error') {
                resp.commonResponse(res.data, from)
            } else {
                resp.commonErrorResponse(from)
            }
        } catch (err) {
            console.log('err', err)
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const clearResponse = () =>
        dispatch({
            type: CLEAR_RESPONSE,
        })

    const clearResponseEdit = () =>
        dispatch({
            type: CLEAR_RESPONSE_EDIT,
        })

    const bidHistoryUpdate = async (formData) => {
        try {
            const from = 'bidHistoryUpdate'
            const [res] = await Promise.all([
                apiCall('post', 'ttwbidhistoryUpdate', formData, '', 'product'),
            ])
            resp.commonResponse(res.data, from)
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const addHistoricValue = async (formData, finishEdit) => {
        try {
            const from = 'addHistoricValue'
            const [res] = await Promise.all([
                apiCall('post', 'royalty/action', formData, '', '', '', true),
            ])
            if (finishEdit === 1) {
                resp.commonResponse(res.data, from)
            }
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const getOfferingsListing = async (formData) => {
        try {
            const from = 'getOfferingsListing'

            let apiPath = 'royalty/search'
            if (formData.list && formData.list == 'pendingQuarterWise') {
                apiPath = 'royalty/pending'
            }

            const [res] = await Promise.all([
                apiCall('post', apiPath, formData, '', '', '', true),
            ])

            if (res.data.status === 'success') {
                dispatch({
                    type: GET_ALL_ROYALTY_INPUTS,
                    payload: {
                        records: res.data.data.responseData.records.length
                            ? res.data.data.responseData.records
                            : [],
                        totalRecords: res.data.data.responseData.totalRecords,
                        setDisp: res.data.data.responseData.setDisp,
                        from: from,
                    },
                })
            } else if (res.data.status === 'error') {
                resp.commonResponse(res.data, from)
            } else {
                resp.commonErrorResponse(from)
            }
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const processRoyaltyPayments = async (formData, noAlert) => {
        try {
            const from = 'processRoyaltyPayments'
            const [res] = await Promise.all([
                apiCall(
                    'post',
                    'royalty/process/payment',
                    formData,
                    '',
                    '',
                    '',
                    true
                ),
            ])
            //if (finishEdit === 1) {
            resp.commonResponse(res.data, from, noAlert)
            //}
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const cancelAllBids = async (formData, noAlert) => {
        try {
            const from = 'cancelAllBids'
            const [res] = await Promise.all([
                apiCall('post', 'cancelAllBids', formData, '', 'product'),
            ])
            resp.commonResponse(res.data, from, noAlert)
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const deletePendingRoyaltyPayments = async (formData, finishEdit) => {
        try {
            const from = 'deletePendingRoyaltyPayments'
            const [res] = await Promise.all([
                apiCall(
                    'post',
                    'royalty/delete/pending/payment',
                    formData,
                    '',
                    '',
                    '',
                    true
                ),
            ])
            resp.commonResponse(res.data, from)
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const getSyncDashboardNetsuiteData = async (formData) => {
        try {
            let from = 'productSyncedCount'
            const [res] = await Promise.all([
                apiCall('post', 'productSyncedCount', formData, '', 'product'),
            ])
            if (res.data.status === 'success') {
                console.log('res.data.datares.data.data', res.data.data)
                dispatch({
                    type: GET_SYNC_DASHBOARD_DATA,
                    payload: {
                        ...res.data.data.responseData,
                    },
                })
            } else if (res.data.status === 'error') {
                resp.commonResponse(res.data, from)
            } else {
                resp.commonErrorResponse(from)
            }
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const manualCloseProductNew = async (formData, fromVariable, noAlert) => {
        try {
            const from = fromVariable ? fromVariable : 'manualCloseProductNew'

            const [res] = await Promise.all([
                apiCall(
                    'post',
                    'manualCloseProductNew',
                    formData,
                    '',
                    'product'
                ),
            ])
            resp.commonResponse(res.data, from, noAlert)
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const getAllAPILogs = async (formData, fromVariable) => {
        try {
            const [res] = await Promise.all([
                apiCall('post', 'apiLogs', formData, '', 'product'),
            ])
            const from = 'search'
            if (res.data.status === 'success') {
                dispatch({
                    type: GET_ALL_API_LOGS,
                    payload: {
                        records: res.data.data.responseData.records.length
                            ? res.data.data.responseData.records
                            : [],
                        totalRecords: res.data.data.responseData.totalRecords,
                        setDisp: res.data.data.responseData.setDisp,
                        from: fromVariable || 'apihistory',
                    },
                })
            } else if (res.data.status === 'error') {
                resp.commonResponse(res.data, from)
            } else {
                resp.commonErrorResponse(from)
            }
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    return (
        <ProductContext.Provider
            value={{
                // buyer_allproducts: state.buyer_allproducts,
                all_products: state.all_products,
                responseStatus: state.responseStatus,
                activelots: state.activelots,
                single_project: state.single_project,
                project_timing_config: state.project_timing_config,
                single_project_label: state.single_project_label,
                search_allbidhistory: state.search_allbidhistory,
                search_allproxyhistory: state.search_allproxyhistory,
                search_allapilogs: state.search_allapilogs,
                search_allttwbidhistory: state.search_allttwbidhistory,
                reconcilation: state.reconcilation,
                all_royalty_inputs: state.all_royalty_inputs,
                mainDashboardSync: state.mainDashboardSync,
                all_project_access_req: state.all_project_access_req,
                all_offers: state.all_offers,
                edit_action_status: state.edit_action_status,
                clearResponse,
                clearResponseEdit,
                getAllProducts,
                getAllOffers,
                getAllAdminOffers,
                changeProductStatus,
                changeOfferStatus,
                getProjectAccessRequest,
                ChangeAuctionIdInProject,
                projectAccessReqStatus,
                getReconsolationData,
                projectAction,
                editAction,
                getSingleProject,
                multiProjectAction,
                getSingleProjectforPrintLabel,
                getCloseTimeConfiguration,
                bulkProjectAction,
                bulkProjectImageAction,
                getAllBidHistory,
                getAllProxyHistory,
                getAllAPILogs,
                getAllTtwBidHistory,
                bidHistoryUpdate,
                addItemToCart,
                addHistoricValue,
                getOfferingsListing,
                processRoyaltyPayments,
                cancelAllBids,
                deletePendingRoyaltyPayments,
                getSyncDashboardNetsuiteData,
                uploadXLSXFile,
                manualCloseProductNew,
            }}
        >
            {props.children}
        </ProductContext.Provider>
    )
}

export default ProductState
